import React, { createContext, useEffect, useState } from "react";
import { setAPIAuthToken } from "api/apiClient";
import { getFiscalProfile } from "api/modules/auth.api";
import Spinner from "components/Spinner";

const UserContext = createContext({
  setAuthToken: () => {},
  setDNI: () => {},
  setEmailValidated: () => {},
  setIsLogged: () => {},
  setPhone: () => {},
  logout: () => {},
  token: null,
  isLogged: false,
  email: null,
  emailValidated: false,
  phone: null,
  userData: null,
});

export const UserProvider = ({ children }) => {
  const [validated, setValidated] = useState(false);

  const [token, setToken] = useState(null);
  const [isLogged, setIsLogged] = useState(false);

  const [dni, setDNI] = useState(null);
  const [phone, setPhone] = useState(null);
  const [emailValidated, setEmailValidated] = useState(false);
  const [userData, setUserData] = useState(null);

  const logout = () => {
    setAuthToken(null);
    setIsLogged(false);
    setUserData(null);
  };

  const setAuthToken = (token) => {
    setAPIAuthToken(token);
    setToken(token);
    localStorage.setItem("fiscal_token", token);
  };

  const fetchFiscalData = async () => {
    try {
      const response = await getFiscalProfile();
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching fiscal data:', error);
      setUserData(null);
    }
  };

  const getTokenFromLocalStorage = () => {
    const token = localStorage.getItem("fiscal_token");
    if (!token || token === "null") {
      setAuthToken(null);
    } else {
      setIsLogged(true);
      setAuthToken(token);
      // Obtener datos del fiscal cuando se autentica
      fetchFiscalData();
    }
    setValidated(true);
  };

  useEffect(getTokenFromLocalStorage, []);

  return (
    <UserContext.Provider
      value={{
        setAuthToken,
        setDNI,
        setEmailValidated,
        setIsLogged,
        setPhone,
        logout,
        token,
        isLogged,
        dni,
        emailValidated,
        phone,
        userData,
      }}
    >
      {validated ? children : <Spinner />}
    </UserContext.Provider>
  );
};

export default UserContext;
